import {IConfigurationValuesService} from '@services/ConfigurationValuesService';
import {IHttpService} from '@services/HttpService';
import {RequireAuthenticationToken} from '@services/http/authorisation-interceptor';
import type { UploadDocumentRequest } from '@swipejobs/i9-document-validations-react';
import {DocumentUploadResponse} from '@models/onboarding-review/section2-document-upload';

export interface IDocumentUploadApiService {
  uploadDocuments(request: UploadDocumentRequest): Promise<DocumentUploadResponse>;
}

export class DocumentUploadApiService implements IDocumentUploadApiService {
  constructor(
    private httpService: IHttpService,
    private configurationValuesService: IConfigurationValuesService
  ) {
  }

  @RequireAuthenticationToken
  async uploadDocuments(request: UploadDocumentRequest): Promise<DocumentUploadResponse> {
    const response = await this.httpService.post<DocumentUploadResponse, UploadDocumentRequest>(
      `${this.configurationValuesService.apiUrl}/worker-onboarding/external/representative/document/base64`,
      request
    )
    return response?.data;
  }
}



// WEBPACK FOOTER //
// ./src/services/document-upload-api-service.ts